import React from "react";
import ATable from "../../common/table";

const DiscoverCaseTable = props => {
  //Column Definition
  const columns = [
    {
      header: "S/N",
      id: "s-n",
      render: row => <div>{props.paginatedCallBack(row.viewIndex)}</div>,
      width: 50
    },
    {
      header: "Case Number",
      accessor: "caseNumber"
    },
    {
      header: "Issuer",
      accessor: "issuer"
    },
    {
      header: "Merchant",
      accessor: "merchant"
    },
    {
      header: "Transaction Reference",
      accessor: "transactionReference"
    },
    {
      header: "Case Amount",
      accessor: "caseAmount"
    },
    {
      header: "Notice Type",
      accessor: "noticeType"
    },
    {
      header: "Status",
      accessor: "caseStatusDescription"
    },
    {
      header: "Sub Status",
      accessor: "subStatusCodeDescription"
    },
    {
      header: "Expiry Date",
      accessor: "cycleCloseDate"
    },
    {
      header: "Created On",
      accessor: "createdOn"
    },
    {
      header: "Created By",
      accessor: "createdBy"
    }
  ];
  return (
    <ATable
      className="-striped -highlight"
      tableData={props.tableData}
      columns={columns}
      loading={props.loading}
      onRowClick={props.onRowClick}
      onChange={props.onTableChange || null}
      manual
      {...props}
    />
  );
};

export default DiscoverCaseTable;



// WEBPACK FOOTER //
// ./src/components/discover/cases/DiscoverCaseTable.js